/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Invariant_BothInputs */

const en_sch_err_invariant_both = /** @type {(inputs: Sch_Err_Invariant_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workflow needs at least one status in Backlog or Unstarted and one in Completed.`)
};

const de_sch_err_invariant_both = /** @type {(inputs: Sch_Err_Invariant_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Workflow braucht mindestens einen Status in Backlog oder Nicht begonnen und einen in Abgeschlossen.`)
};

/**
* | output |
* | --- |
* | "A workflow needs at least one status in Backlog or Unstarted and one in Completed." |
*
* @param {Sch_Err_Invariant_BothInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_invariant_both = /** @type {((inputs?: Sch_Err_Invariant_BothInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Invariant_BothInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_invariant_both(inputs)
	return en_sch_err_invariant_both(inputs)
});